import { Controller } from "@hotwired/stimulus"

/**
 * Skeleton Loader Controller
 *
 * Removes the skeleton placeholder once the enclosing
 * Turbo Frame finishes loading its content.
 */
export default class extends Controller<HTMLElement> {
  connect() {
    this.element.closest("turbo-frame")?.addEventListener("turbo:frame-load", () => {
      this.element.remove()
    })
  }
}
